<template>
  <div class="home">
    <Login msg="Login"/>
  </div>
</template>

<script>
// @ is an alias to /src
import Login from '@/components/login.vue'

export default {
  name: 'LoginView',
  components: {
    Login
  }
}
</script>
